import React from "react";
import { Col, Row, Card } from "react-bootstrap";
import AgentCell from "../../../components/AgentCell";

const CaseHeader = ({ caseRecord, showAgentInfo = false, ...props }) => {
  return (
    <Row>
      <Col>
        <Card>
          <Card.Body>
            {props.keySlot || (
              <>
                <b>Clave: </b>
                {caseRecord.caseTicket}
              </>
            )}
            <br />
            {props.insuredSlot || (
              <>
                <b>Asegurado: </b>
                {`${caseRecord.assuredName} ${caseRecord.assuredFlastname} ${caseRecord.assuredMlastname}`}
              </>
            )}
            <br />
            {props.incomeTypeSlot || (
              <>
                <b>Tipo de Ingreso: </b>
                {caseRecord.incomeType}
              </>
            )}
            <br />
            {props.comprehensiveCare || (
              <>
                <b>Cuidado Integral: </b>
                {caseRecord.comprehensiveCare || 'NO'}
              </>
            )}
            <br />
            {props.diagnosisSlot || (
              <>
                <b>Diagnostico Presuntivo: </b>
                {caseRecord.diagnosis}
              </>
            )}
            <br />
            {props.requiresTabulationSlot || (
              <>
                <b>Solicitud de tabulacion: </b>
                {caseRecord.requiresTabulation}
              </>
            )}
            <br />
            <>
              <b>Coaseguro honorarios medicos: </b>
              ${caseRecord.medicalFeesCoinsurance || '0'}
            </>
            <br />
            <>
              <b>Coaseguro: </b>
              ${caseRecord.coinsurance || '0'}
            </>
            <br />
            <>
              <b>Deducible: </b>
              ${caseRecord.deductible || '0'}
            </>
          </Card.Body>
        </Card>
      </Col>
      <Col>
        <Card>
          <Card.Body>
            {props.hospitalIdenSlot || (
              <>
                <b>Folio Hospital / Episodio: </b>
                {caseRecord.hospitalIden}
                <br />
              </>
            )}
            {props.hospitalNameSlot || (
              <>
                <b>Hospital: </b>
                {caseRecord.hospital?.hospitalName}
                <br />
              </>
            )}
            {props.hospitalModelSlot || (
              <>
                <b>Modelo: </b>
                {caseRecord.hospital?.model}
                <br />
              </>
            )}
            {props.caseTypeSlot || (
              <>
                <b>Tipo de TRÁMITE: </b>
                {caseRecord.caseType}
                <br />
              </>
            )}
            {caseRecord.hospital?.atc?.toLowerCase() === 'si' && (props.invoiceAtcSlot || (
              <>
                <b>Folio estado de cuenta ATC: </b>
                {caseRecord.invoiceATC}
                <br />
              </>
            ))}
            {caseRecord.hospital?.atc?.toLowerCase() === 'si' && (props.typeInvoiceAtc || (
              <>
                <b>Tipo de folio ATC: </b>
                {caseRecord.typeInvoice}
                <br />
              </>
            ))}
            {caseRecord.hospital?.atc?.toLowerCase() === 'no' && (
              <>
                  <b>Tipo de visado: </b>
                  Manual
                  <br />
              </>
            )}
            {showAgentInfo && (
              <>
                <b>ID Agente: </b>
                <AgentCell
                  businessAgentId={caseRecord?.agentId}
                  fallback={caseRecord?.agent?.agentId || 'N/A'}
                  field="agentId"
                />
                <br />
                <b>Nombre Agente: </b>
                <AgentCell
                  businessAgentId={caseRecord?.agentId}
                  fallback={caseRecord?.agent?.agentName || 'N/A'}
                  field="agentName"
                />
                <br />
                <b>Promotoría: </b>
                <AgentCell
                  businessAgentId={caseRecord?.agentId}
                  fallback={caseRecord?.agent?.promoterEdit || 'N/A'}
                  field="promoterEdit"
                />
              </>
            )}
            {props.rightHeaderSlot}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default CaseHeader;
